import { Box, Stack, Typography } from '@mui/material';


const UpperText = () => {
    return (


        <Box>

            <Stack spacing={1} p={3} color="#969699">

                
                        <Typography variant='h2'>

                            IP Address Lookup
                            </Typography>
            </Stack>

        <Stack spacing={1} p={2}>

            <Typography>
          Enter the IP address in the box below, then click "Get IP Details."
            </Typography>
        </Stack>
    </Box>
        
    );
}

export default UpperText;